module.exports = __webpack_public_path__ + "DejaVuSerif-Bold.25670b4ac8dafec3250b.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/DejaVu/DejaVuSerif-Bold.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/fonts/DejaVu/DejaVuSerif-Bold.ttf?v=1.1
// module chunks = styles